import Http from "../../../core/http-axios-react/http/Http";
import { HttpBaseResponse, HttpData } from "../../../core/HttpResponse";
import { I_Report } from "../type/report";

export const getReports = async ({
  type,
  end_date,
  start_date,
  page,
}: {
  type?: string;
  start_date?: string;
  end_date?: string;
  page: number;
}) => {
  const results = await Http.get<HttpBaseResponse<HttpData<I_Report[]>>>({
    url: `/exports`,
    params: {
      export_type: type,
      start_date,
      end_date,
      page,
    },
  });
  return results;
};

export const storeExports = async ({
  end_date,
  export_type,
  id,
  start_date,
}: {
  export_type: string;
  id?: number | number[];
  start_date?: string;
  end_date?: string;
}) => {
  const results = await Http.post({
    url: "/exports",
    data: {
      end_date,
      export_type,
      id,
      start_date,
    },
  });
  return results;
};

export const downloadReport = async ({ id }: { id: number }) => {
  const results = await Http.get({
    url: `/exports/${id}/download`,
  });
  return results;
};

export const deleteReport = async ({ id }: { id: number }) => {
  const results = await Http.delete({
    url: `/exports/${id} `,
  });
  return results;
};
